import { Component, Element, Prop, h } from '@stencil/core';

import { actions as pageParamsActions } from '../actions/actions.page-params';
import { onVehicleConfigInit } from '../actions/actions.vehicle-config';
import { state as answerState, on as onAnswerStateChange } from '../store/store.answers';
import { state as dynamicEntryState } from '../store/store.dynamic-entry';
import { on as onVehicleConfigStoreChange, state as vehicleConfigState } from '../store/store.vehicle-config';
import { trackVehDetailImpression } from '../tracking/tracking.detail';

@Component({
  tag: 'ico-vehicle-config-hydrator',
  shadow: true,
})
export class IcoVehicleConfigHydrator {
  @Prop() yearId!: number;
  @Prop() makeId!: number;
  @Prop() modelId!: number;
  @Prop() trimId!: number;
  @Prop() colorId: number;
  @Prop() vin: string = '';
  @Prop() dealerId: number;
  @Prop() selectedOptions: number[] = [];
  @Prop() allowIneligibleVehicleSubmission: boolean = false;

  // Analytics
  @Prop() entry: string;
  @Prop() offerCode: string;
  @Prop() lnxCode: string;
  @Prop() category: string;

  @Prop() isDigitalRetailing: boolean = false;
  @Prop() theme: string;

  @Element() el: HTMLElement;

  async componentWillLoad() {
    pageParamsActions.onReceivedParams({ entry: this.entry, offerCode: this.offerCode, lnxCode: this.lnxCode, category: this.category });

    await onVehicleConfigInit(this.yearId, this.makeId, this.modelId, this.trimId, this.colorId, this.vin, this.dealerId, this.selectedOptions);

    onVehicleConfigStoreChange('set', (prop, value) => {
      this.el.childNodes.forEach((element) => {
        element[prop] = value;
      });
    });

    onAnswerStateChange('set', (prop, value) => {
      this.updateStateProps(prop, value);
    });

    this.setupStateProps();
    trackVehDetailImpression();
  }

  // explicitly declare initial state props
  setupStateProps() {
    const allowIneligibleVehicleSubmission = this.allowIneligibleVehicleSubmission || dynamicEntryState.allowIneligibleVehicleSubmission;
    this.el.childNodes.forEach((element) => {
      element['vehicleConfig'] = vehicleConfigState;
      element['dealerInfo'] = answerState.dealerInfo;
      element['vehicle'] = answerState.vehicle;
      element['vehicleTrimId'] = this.trimId;
      element['isDigitalRetailing'] = this.isDigitalRetailing;
      element['theme'] = this.theme;
      element['allowIneligibleVehicleSubmission'] = allowIneligibleVehicleSubmission;
    });
  }

  // updates only the changed prop
  updateStateProps(prop, value) {
    this.el.childNodes.forEach((element) => {
      element[prop] = value;
    });
  }

  render() {
    return (
      <div class="hydration-container hydration-container--vehicle-config">
        <slot />
      </div>
    );
  }
}
